import { SelectableTransaction } from './selectable-transaction';
import { Tba } from './tba';

export class TbaTransaction extends SelectableTransaction {
  tbas: Tba[];
  included: boolean; // marks already included transaction
}
